var React = require('react');

function MenuShapePauseInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"55.1364","y":"514.941","width":"190.144","height":"530.346","transform":"rotate(-73.1738 55.1364 514.941)","stroke":"#FF00FF","key":0}),React.createElement("rect",{"x":"132.851","y":"262.937","width":"190.144","height":"530.346","transform":"rotate(-73.1738 132.851 262.937)","stroke":"#FF00FF","key":1})]);
}

MenuShapePauseInline.defaultProps = {"width":"750","height":"750","viewBox":"0 0 750 750","fill":"none"};

module.exports = MenuShapePauseInline;

MenuShapePauseInline.default = MenuShapePauseInline;
